exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.size-dropdown[data-v-561cae5a]{width:125px\n}\n.system-font[data-v-561cae5a]{font-family:Arial, Helvetica, sans-serif;font-size:11px\n}\n", ""]);

// exports
